import { defineMessages } from 'react-intl-next';

import {
  characterReplacer,
  setToUnicodeMap,
} from './highlighted-character-replacement';

const messages = defineMessages({
  tooltipText: {
    id: 'bitkit.diff.bidiCharacterText',
    description:
      'Message shown in tooltip to warn about bidirectional characters',
    defaultMessage:
      'Bidirectional characters change the order that text is rendered. This could be used to obscure malicious code.',
  },
});

const BIDI_SET = new Set([
  '\u202a',
  '\u202b',
  '\u202c',
  '\u202d',
  '\u202e',
  '\u2066',
  '\u2067',
  '\u2068',
  '\u2069',
]);

const BIDI_CHARACTERS = setToUnicodeMap(BIDI_SET);

const [regEx, replaceBidiCharacters, UnicodeReplacement] = characterReplacer(
  BIDI_CHARACTERS,
  messages.tooltipText
);

export const ReplaceBidiCharactersDiff = (text: string) => {
  const matches = text.match(regEx);

  if (matches) {
    const parts = text.split(regEx);
    return parts.flatMap((part, i) =>
      matches[i]
        ? [
            part,
            <UnicodeReplacement
              str={BIDI_CHARACTERS.get(matches[i])}
              key={i}
            />,
          ]
        : [part]
    );
  }

  return text;
};

export { regEx as bidiRegExp };
export { replaceBidiCharacters };
